import { DASHBOARD, PROTECTED } from '@/lib/constants/routes';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <main className="min-h-screen p-5 flex justify-center items-center bg-page-background">
      <div className="flex flex-col sm:flex-row items-center gap-[45px]">
        <img
          src="/ghost_not_found.png"
          alt="not found"
          className="w-[254px] aspect-square pointer-events-none shrink"
        />
        <div className="flex flex-col items-center gap-11">
          <section className="flex flex-col gap-2">
            <h1 className="font-bold text-[48px]">
              {t('404_not_found.courtesy_title')}
            </h1>
            <h2 className="font-bold text-xl">
              {t('404_not_found.courtesy_subtitle')}
            </h2>
            <p className="font-thin text-xl text-[#939393]">
              {t('404_not_found.courtesy_message')}
            </p>
          </section>
          <Link to={`${PROTECTED}${DASHBOARD}`}>
            <button className="flex justify-center items-center w-[200px] h-[30px] rounded-[6px] py-5 text-background bg-foreground cursor-pointer">
              {t('404_not_found.go_dashboard_button_text')}
            </button>
          </Link>
        </div>
      </div>
    </main>
  );
};
